import { message } from '@utils/wuji-message';
import hljs from 'highlight.js';
import { marked } from 'marked';
import { getUUID } from '@/utils/common';
import { writeClipboard } from '@utils/clipboard';
import '@/styles/hljs.scss';
// interface IRendererOptions {
//   reset?: () => void;
// }
const resetButtonId = (id) => `btn-reset-${id}`;
const copyButtonId = (id) => `btn-copy-${id}`;
export const getCustomRender = () => {
    const renderer = new marked.Renderer();
    renderer.code = function (code, language = 'javascript') {
        const buttonId = getUUID();
        const reset = null;
        let buttons = '';
        if (false && language === 'commands') { // 先不用逐个reset
            buttons = ` <span class="code-enhance-button" id=${resetButtonId(buttonId)}>reset</span>`;
        }
        else {
            buttons = `<span class="code-enhance-button" id=${copyButtonId(buttonId)}>copy</span>`;
        }
        const header = `
    <div class="code-enhance-header">
      <span>${language}</span>
      <div class="code-enhance-header-buttons">
      ${buttons}
      </div>
    </div>
  `;
        let highlightedCode = '';
        if (language === 'commands') {
            highlightedCode = hljs.highlight('plaintext', code).value;
            highlightedCode = `<pre class="commands">${highlightedCode}</pre>`;
        }
        else {
            const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
            highlightedCode = `<pre>${hljs.highlight(validLanguage, code).value}</pre>`;
        }
        setTimeout(() => {
            const resetBtn = document.querySelector(`#${resetButtonId(buttonId)}`);
            const copyBtn = document.querySelector(`#${copyButtonId(buttonId)}`);
            if (resetBtn && reset) {
                resetBtn.addEventListener('click', reset);
            }
            if (copyBtn) {
                copyBtn.addEventListener('click', () => {
                    writeClipboard(code);
                    message.success('复制成功');
                });
            }
        }, 0);
        return `<div class="code-enhance">${header}\n<div class="code-enhance-codeblock">${highlightedCode}</div></div>`;
    };
    return renderer;
};
